import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgShare = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5 14V16C5 17.6569 6.34315 19 8 19H16C17.6569 19 19 17.6569 19 16V14M11.9995 12V5M11.9995 5L9 8M11.9995 5L15 8.00048",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgShare;
